var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingProfile,
          expression: "loadingProfile"
        }
      ]
    },
    [
      _c("div", { staticClass: "card-style card-top-right load-up" }, [
        _c("div", { staticClass: "card-content-left card-height" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.info.left.label))
          ]),
          _vm._v(" "),
          !_vm.loadingProfile
            ? _c(
                "div",
                { staticClass: "value" },
                [
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.info.left.value,
                      duration: 2600,
                      decimals: _vm.info.decimal ? _vm.info.numberOfDecimal : 0
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.info.unit))])
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-icon card-height",
            style: _vm.info.center.style
          },
          [
            _c(
              "span",
              { staticStyle: { "font-size": "3em", color: "White" } },
              [_c("i", { class: _vm.info.center.icon })]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-content-right card-height" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.info.right.label))
          ]),
          _vm._v(" "),
          !_vm.loadingProfile
            ? _c(
                "div",
                { staticClass: "value" },
                [
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.info.right.value,
                      duration: 2600,
                      decimals: _vm.info.numberOfDecimal
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.info.unit))])
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }